<template>
    <div id="footer_link_item"
         @click="onClick">
        <button class="hyperlinkButton">
            <img :src="require('@/images/icons/' + myImagename + '')"/>
            {{ myText }}
        </button>
    </div>
</template>

<script type="text/javascript">
    export default {
        name: 'Hyperlink', 
        
        props: {
            myImagename: String,
            myText: String
        },

        components: {
          
        },
        data: function () {
            return {
            }
        },
        methods: {
            onClick() {
                this.$emit('clicked');
            }
        },
    }
    
</script>

<style scoped>
    @import '../css/main.css';
</style>